import Network from 'infrastructure/js/modules/network';
import * as formActionsHelper from '../../Forms/formActionsHelper';
import { api as messageDialogApi } from '../../MessageDialog/messageDialogActions.js';
import * as materialsService from '../../../services/Materials/materialsService.js';
import * as qplsService from '../../../services/Qpls/qplsService.js';
import { formsNames } from '../../../enums/formsNames';
import { getResponseValidationDetails } from 'infrastructure/js/components/Form/formHelper';
import uniqBy from 'lodash-es/uniqBy';
import {FormModes} from '../../../components/Administration/MatSettingsPage/utils/qplHelper';

const config = {
  getSubmitMethod: () => null, //set null when override the formActionsHelper's submit() method
};

export const actionTypes = {
  ...formActionsHelper.getActionTypes(formsNames.QPL_FORM),
  QPL_FORM_SET_QPL_ID: 'QPL_FORM_SET_QPL_ID',
};

const actions = {
  ...formActionsHelper.getActions(formsNames.QPL_FORM),

  setQplId: function(payload) {
    return {type: actionTypes.QPL_FORM_SET_QPL_ID, payload: payload };
  }
};

export let api = {
  ...formActionsHelper.getApiActions(actions, config),


  fetchFormItem(dispatch, getState) {
    return function (id) {
      dispatch(actions.setBusy(true));

      return qplsService.getQpl(id).then(response => {
        dispatch(actions.setBusy(false));

        if (!Network.isResponseValid(response)) {
          console.error('fetch QPL failed', response);
          messageDialogApi.responseError(dispatch, getState)(response);
          return null;
        }
        if (!response.data) {  //should never get here
          console.error('qpl not found', response);
          messageDialogApi.showError(dispatch, getState)();
          return null;
        }

        return response?.data;
      })
    }
  },

  fetchFormData(dispatch, getState) {
    return function () {
      dispatch(actions.setBusy(true));

      return materialsService.fetchAllMaterials().then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error('Fetch materials failed', response);
          messageDialogApi.responseError(dispatch, getState)(response);
          return {success: false};
        }

        let materials = response.dataList.filter((obj) => {return !!obj.materialName});
        materials = uniqBy(materials, 'materialName');

        let formData = {
          materials: materials.map((obj) => {return {value: obj.id, label: obj.materialName, data: obj}}),
        };

        dispatch(actions.fetchFormDataReady(formData));
        dispatch(actions.setBusy(false));

        return { success: true };
      });
    };
  },


  submit(dispatch, getState) {
    return function (data, formMode, reloadParentComponent) {
      dispatch(actions.setBusy(true));

      let method = _getMethodByMode(formMode);

      method?.(data).then((response) => {
        dispatch(actions.setBusy(false));

        let validations = getResponseValidationDetails(response);
        if (validations) {
          dispatch(actions.setValidationWarningsData(validations));
          return { success: false };
        }

        if (!Network.isResponseValid(response)) {
          console.error('Create/Edit QPL failed', response);
          messageDialogApi.responseError(dispatch, getState)(response);
          return { success: false };
        }

        if (reloadParentComponent) {
          reloadParentComponent(response.data);
        }

        return { success: true };
      });
    };
  },

};

export let jsxActions = {
  ...formActionsHelper.getJsxActions(api),

  setQplId(qplId) {
    return function (dispatch, getState) {
      dispatch(actions.setQplId(qplId));
    }
  },

  fetchFormItem(materialTypeId) {
    return function (dispatch, getState) {
      return api.fetchFormItem(dispatch, getState)(materialTypeId);
    };
  },

  submit(data, formMode, reloadParentComponent) {
    return function (dispatch, getState) {
      return api.submit(dispatch, getState)(data, formMode, reloadParentComponent);
    };
  },

};

/////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS

function _getMethodByMode(formMode) {
  switch (formMode) {
    case FormModes.CREATE:
      return qplsService.createQpl;
    case FormModes.EDIT:
      return qplsService.editQpl;
    case FormModes.CLONE:
      return qplsService.cloneQpl;
    case FormModes.UPDATE:
      return qplsService.updateQplVersion;
    default:
      console.error('Unknown QPL form mode:', formMode);
      return null;
  }
}
